import { useSyncExternalStore } from "react";

let isLive = false;
const listeners = new Set<() => void>();

export const setEMRLive = (value: boolean) => {
  if (isLive === value) return;
  isLive = value;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => isLive;

export const useIsEMRLive = () => useSyncExternalStore(subscribe, getSnapshot);

export const pollUnlessLive = (
  isLive: boolean,
  intervalMs: number
): number | false => (isLive ? false : intervalMs);
